<div class="custom-select-container" [class.open]="isOpen">
  <label [for]="label" class="fs-14 fw-normal font-white mb-1 d-block" *ngIf="label">{{ label }}</label>

  <div class="selected-value" (click)="toggleDropdown()" (keydown)="toggleDropdown()" tabindex="0">
    <span class="text-truncate" [class.placeholder-text]="!model || (isMultiSelect && model.length === 0)">{{ selectedItemDisplay }}</span>
    <span class="dropdown-arrow ms-auto"></span>
  </div>

  <div *ngIf="isOpen" class="dropdown-list">
    <div class="search-container">
      <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="searchText" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
    </div>

    <div *ngIf="isMultiSelect && showSelectAll && !searchText" class="dropdown-item select-all-item" (click)="toggleSelectAll()">
      <span class="checkbox" [class.checked]="isAllSelected()">
        <span class="checkmark" *ngIf="isAllSelected()">✔</span>
      </span>
      <span>Select all options</span>
    </div>

    <div *ngFor="let item of filteredItems" class="dropdown-item" [class.selected]="isSelected(item)" (click)="selectItem(item)" (keydown)="selectItem(item)" tabindex="0">
      <span class="checkbox" [class.checked]="isSelected(item)">
        <span class="checkmark" *ngIf="isSelected(item)">✔</span>
      </span>
      <span>{{ item[displayProperty] }}</span>
    </div>

    <div *ngIf="filteredItems.length === 0" class="p-3 text-center" style="color: var(--font-color-gray-opacity); font-size: 14px">No results found</div>
  </div>
</div>

<div class="selected-items-wrapper" *ngIf="isMultiSelect && getSelectedItems().length > 0">
  <div *ngFor="let item of getSelectedItems()" class="chip">
    <span>{{ item[displayProperty] }}</span>
    <span class="remove-icon" (click)="removeItem(item, $event)">×</span>
  </div>
</div>
